import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import styled from 'styled-components';
import { motion } from 'framer-motion';

import Exit from '../subComponents/Exit';
import SocialIcons from '../subComponents/SocialIcons';
import Location from '../assets/Images/location.jpg';
import Letter from '../assets/Images/sent.png';

const transition = { duration: 1.4, ease: [0.6, 0.01, -0.05, 0.9] };

const Container = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  position: relatve;
  background-color: ${(props) => props.theme.body};
  color: ${(props) => props.theme.text};
  overflow: hidden;
`;

const Map = styled.div`
  position: fixed;
  bottom: 0%;
  margin: auto;
  left: 0;
  right: 0;
  text-align: center;
  height: 65vh;

  img {
    height: 100%;
    width: 90vw;
    border-radius: 16px 16px 0 0;
    box-shadow: -1px -1px 20px 6px rgba(0, 0, 0, 0.5);
  }

  @media (max-width: 1024px) {
    height: 55vh;
  }

  @media (max-width: 450px) {
    height: 60vh;
    left: 10%;

    img {
      width: auto;
    }
  }
`;

const Title = styled(motion.h1)`
  font-family: 'Syne', sans-serif;
  position: fixed;
  top: 25%;
  left: 3%;
  font-size: calc(3.5rem + 5vw);
  text-shadow: 3px 2px 4px ${(props) => props.theme.body};
  color: ${(props) => `rgba(${props.theme.textRgba}, 0.7)`};

  @media (max-width: 440px) {
    font-size: calc(2.5rem + 5vw);
  }
`;

const Main = styled(motion.div)`
  position: fixed;
  top: 20%;
  right: 15%;
  display: flex;
  flex-direction: column;
  background: ${(props) => `rgba(${props.theme.bodyRgba}, 0.9)`};
  border: 2px solid ${(props) => `rgba(${props.theme.textRgba}, 0.5)`};
  box-shadow: -1px 0px 14px 3px
    ${(props) => `rgba(${props.theme.textRgba}, 0.3)`};
  width: 27vw;
  height: 70vh;
  padding: 3rem;
  z-index: 2;

  button {
    position: relative;
    width: 100%;
    outline: none;
    cursor: pointer;
    font-size: calc(0.3rem + 1vw);
    font-family: 'Syne', sans-serif;
    color: ${(props) => props.theme.text};
    background: ${(props) => props.theme.body};
    letter-spacing: 0.2rem;
    text-align: center;
    padding: 1.2rem;
    margin-top: 2rem;
    z-index: 4;
    border-radius: 1.5rem;

    border-top-color: transparent;
    border-left-color: transparent;
    border-bottom-color: ${(props) => props.theme.text};
    border-right-color: ${(props) => props.theme.text};
    transition: 0.2s ease-in-out;
    box-shadow: inset -2px -2px 6px
        ${(props) => `rgba(${props.theme.textRgba}, .7)`},
      inset -3px -3px 5px ${(props) => `rgba(${props.theme.bodyRgba}, .9)`},
      inset 3px 3px 3px ${(props) => `rgba(${props.theme.bodyRgba}, .2)`},
      inset 3px 3px 5px ${(props) => `rgba(${props.theme.textRgba}, .4)`};
  }

  button:before,
  button:after {
    position: absolute;
    content: '';
    width: 0%;
    height: 0%;
    border: 2.7px solid;
    border-radius: 1.5rem;
    z-index: -1;
    transition: all 0.3s ease;
  }
  button:before {
    top: 0;
    left: 0;
    border-bottom-color: transparent;
    border-right-color: transparent;
    border-top-color: ${(props) => props.theme.text};
    border-left-color: ${(props) => props.theme.text};
  }
  button:after {
    bottom: 0;
    right: 0;
    background: ${(props) => `rgba(${props.theme.textRgba}, 0.3)`};
    border-top-color: transparent;
    border-left-color: transparent;
    border-bottom-color: ${(props) => props.theme.text};
    border-right-color: ${(props) => props.theme.text};
  }

  button:hover:before,
  button:hover:after {
    border-color: ${(props) => props.theme.text};
    height: 110%;
    width: 103%;
  }

  @media (max-width: 1024px) {
    width: 60vw;

    button {
      font-size: calc(0.5rem + 1vw);
    }
  }

  @media (max-width: 440px) {
    padding: 2rem;
    top: 35%;
    right: 10%;

    button {
      padding: 0.9rem;
    }
  }
`;

const InputBox = styled.div`
  position: relative;
  width: 100%;
  margin-top: 10px;

  input,
  textarea {
    background: transparent;
    width: 100%;
    padding: 7px 0;
    font-size: calc(0.5rem + 1vw);
    margin: 10px 0;
    border: none;
    color: ${(props) => props.theme.text};
    border-bottom: 3px solid #333;
    outline: none;
    resize: none;
  }

  h3 {
    position: absolute;
    left: 0;
    font-size: calc(0.7rem + 1vw);
    font-weight: 400;
    padding: 5px 0;
    margin: 10px 0;
    pointer-events: none;
    color: #666;
    transition: 0.5s;
  }

  input:focus ~ h3,
  input:valid ~ h3 {
    color: #e91e63;
    font-size: calc(0.2rem + 1vw);
    transform: translateY(-20px);
  }

  textarea:focus ~ h3,
  textarea:valid ~ h3 {
    color: #e91e63;
    font-size: calc(0.2rem + 1vw);
    transform: translateY(-23px);
  }

   @media (max-width: 440px) {
   input:focus ~ h3,
  input:valid ~ h3 {
    font-size: calc(0.4rem + 1vw);
    transform: translateY(-10px);
  }

  textarea:focus ~ h3,
  textarea:valid ~ h3 {
    font-size: calc(0.4rem + 1vw);
    transform: translateY(-15px);
  }
   }
`;

const Sent = styled.div`
  p {
    text-align: center;
    font-size: calc(0.4rem + 1vw);
    color: ${(props) => props.theme.text};
    margin-top: 1rem;
  }

  img {
    position: absolute;
    left: 0;
    width: 100%;
    height: auto;
    z-index: 10;
  }
`;

const Result = () => {
  return (
    <Sent>
      <p>Thank you! I will give you a response soon ^-^ </p>
      <motion.img
        initial={{ x: 0, y: '-60vh', opacity: 1 }}
        animate={{
          opacity: 0,
          x: 600,
          transition: { delay: 1, duration: 2 }
        }}
        src={Letter}
        alt="message sent"
      />
    </Sent>
  );
};

const MySkillsPage = (props) => {
  const form = useRef();
  const [result, showResult] = useState(false);
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_vobx9gm',
        'template_sfk8hrb',
        form.current,
        'oiSM7bnYK0aW59ibh'
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
    showResult(true);
  };

  setTimeout(() => {
    showResult(false);
  }, 6000);

  return (
    <Container>
      <motion.div exit={{ opacity: 0 }}>
        <Exit />
        <SocialIcons />
      </motion.div>
      <Map>
        {' '}
        <motion.img
          initial={{
            y: 500,
            opacity: 0
          }}
          animate={{
            y: 0,
            opacity: 1,
            transition: { delay: 0.1, ...transition }
          }}
          exit={{ y: 600, opacity: 0 }}
          transition={transition}
          src={Location}
          alt="My Location"
        />
      </Map>
      <Title
        initial={{
          x: -600
        }}
        animate={{
          x: 0,
          transition: { type: 'spring', delay: 0, ...transition }
        }}
        exit={{ x: -600, opacity: 0 }}
        transition={transition}
      >
        Contact
      </Title>

      <Main
        initial={{
          x: 700,
          opacity: 0
        }}
        animate={{
          x: 0,
          opacity: 1,
          transition: { type: 'spring', delay: 0.2, ...transition }
        }}
        exit={{ x: 600, opacity: 0 }}
        transition={transition}
      >
        <form ref={form} onSubmit={sendEmail}>
          <InputBox>
            <input type="text" name="name" required />
            <h3>Name</h3>
          </InputBox>
          <InputBox>
            <input type="text" name="email" required />
            <h3>Email</h3>
          </InputBox>
          <InputBox>
            <input type="text" name="phone" required />
            <h3>Phone Number</h3>
          </InputBox>

          <InputBox>
            <textarea name="message" required />
            <h3>Type your Message</h3>
          </InputBox>

          <button>SUBMIT</button>
          <div>{result ? <Result /> : null}</div>
        </form>
      </Main>
    </Container>
  );
};

export default MySkillsPage;
